import Vue from 'vue'
import App from './App.vue'
import router from './router'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import toast from '@/lib/cinnamon-toast/CinnamonToastPlugin.js'
import clip from '@/lib/clipboard/ClippyPlugin.js'
import moment from 'moment'
import store from '@/store/store.js'

// Register all components in the components directory globally
const requireComponent = require.context('./components', true, /[A-Z]\w+\.vue$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^.*[\\/]/, '').replace(/\.[^/.]+$/, '')
    )
  )
  // Register component globally
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.use(toast)
Vue.use(clip)

// filters
Vue.filter('date', function (value) {
  if (!value) return ''
  return moment.utc(value).local().format('MM-DD-YYYY, h:mm:ss z')
})
Vue.filter('number', function (value) {
  if (!value) return ''
  return Number(value).toLocaleString()
})
Vue.filter('percentage', function (value) {
  if (value) return parseFloat(value).toFixed(2) + '%'
  return '0%'
})
Vue.filter('currency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    console.log(`%c
  -----------------------------------------
  ▓█████▄  ▄▄▄       ██▓  ██████▓██   ██▓
  ▒██▀ ██▌▒████▄    ▓██▒▒██    ▒ ▒██  ██▒
  ░██   █▌▒██  ▀█▄  ▒██▒░ ▓██▄    ▒██ ██░
  ░▓█▄   ▌░██▄▄▄▄██ ░██░  ▒   ██▒ ░ ▐██▓░
  ░▒████▓  ▓█   ▓██▒░██░▒██████▒▒ ░ ██▒▓░
   ▒▒▓  ▒  ▒▒   ▓▒█░░▓  ▒ ▒▓▒ ▒ ░  ██▒▒▒
   ░ ▒  ▒   ▒   ▒▒ ░ ▒ ░░ ░▒  ░ ░▓██ ░▒░
   ░ ░  ░   ░   ▒    ▒ ░░  ░  ░  ▒ ▒ ░░
     ░          ░  ░ ░        ░  ░ ░
   ░                             ░ ░
  -----------------------------------------
    `, 'color:#0082ca;')
  }
}).$mount('#daisy')
